import {
  AppBar,
  Box,
  Button,
  Dialog,
  Paper,
  DialogContent,
  IconButton,
  Stack,
  Toolbar,
  Typography,
  Grid,
} from "@mui/material";
import {
  Close as CloseIcon,
  Edit as EditIcon,
  SsidChart as DownloadECGIcon,
  SignalCellularAlt as DownloadParamsIcon,
} from "@mui/icons-material";
import { useGetPatientReports, useGetReportById } from "../useReportQueries";

import { LoadingError, LoadingPaper } from "../../LoadingComponents";
import { useEffect, useRef, useState } from "react";
import { useGetPatientById } from "../../PatientComponents";
import CanvasJSReact from "@canvasjs/react-charts";
import { getPressureLayout, getSPO2Layout } from "./reportUtils/spo2Report";
import {
  prettify,
  renderEUDate,
  renderEUDateTime,
  renderDateUTC,
  convertServerToLocalDatetime,
} from "../../../utils/utils";

function SPO2Report({ report_id, patient_id, closeModal }) {
  var CanvasJSChart = CanvasJSReact.CanvasJSChart;

  // === web service queries/mutations ===
  const reportQuery = useGetPatientReports(patient_id, 1, {
    page: 1,
    per_page: 20,
  });
  const reportInfo = useGetReportById(report_id);
  const patientQuery = useGetPatientById(patient_id);

  // === report display ===
  const [layout, setLayout] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // parse csv
    if (!loaded && reportQuery.isSuccess) {
      let measures = reportQuery.data.reports;
      let datapointsSPO2 = [];
      // let datapointsPmin = [];
      let datapointsHR = [];

      // only get last 20 measurements
      if (measures.length > 20) {
        measures = measures.slice(0, 20);
      }

      // prendo le misurazioni di pressioni/hr + data
      measures.forEach((report, index) => {
        if (
          report.data.SPO2 !== null &&
          report.data.SPO2 !== undefined &&
          report.data.HR !== null &&
          report.data.HR !== undefined
        ) {
          datapointsSPO2.push({
            x: report.data.Date,
            y: Number(report.data.SPO2),
          });

          datapointsHR.push({
            x: report.data.Date,
            y: Number(report.data.HR),
          });
        }
      });

      // genero il report
      const layout = getSPO2Layout(datapointsSPO2, datapointsHR);

      setLayout(layout);

      setLoaded(true);
    }
  }, [reportQuery.status]);

  return (
    <>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={closeModal}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <DialogContent>
        {reportQuery.isLoading || reportInfo.isLoading || !loaded ? (
          <LoadingPaper />
        ) : reportQuery.isError || reportInfo.isError ? (
          <LoadingError error={reportQuery.error} />
        ) : (
          reportInfo.isSuccess && (
            <Stack spacing={2} direction={"column"}>
              <Paper sx={{ padding: "10px" }}>
                <Box sx={{ width: "100%" }}>
                  <Box sx={{ float: "left" }}>
                    <Typography fontWeight={"bold"} variant="h5">
                      Misurazione SPO2
                    </Typography>
                  </Box>
                </Box>

                <Grid container>
                  <Grid item xs={6}>
                    <Typography>
                      Assitito:{" "}
                      {patientQuery.isLoading
                        ? ""
                        : `${patientQuery.data.first_name} ${patientQuery.data.last_name}`}
                    </Typography>
                    <Typography>
                      Dispositivo: {prettify(reportInfo.data.origin)}
                    </Typography>
                    <Typography>
                      Data misurazione:
                      {renderEUDateTime(
                        convertServerToLocalDatetime(reportInfo.data.data.Date),
                      )}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    {/* <Typography>Durata: {prettify(selected.duration)}</Typography> */}
                    <Typography>
                      SPO2 media: {reportInfo.data.data.SPO2}%
                    </Typography>
                    <Typography>
                      Frequenza Cardiaca: {reportInfo.data.data.HR}{" "}
                      {reportInfo.data.data.HR != null ? "bpm" : ""}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
              {reportQuery.isLoading ? (
                <LoadingPaper />
              ) : reportQuery.isError ? (
                <LoadingError error={reportQuery.error} />
              ) : (
                <Paper sx={{ padding: "10px" }}>
                  {layout !== undefined && loaded && (
                    <CanvasJSChart
                      key={layout?.title?.text ?? "spo2-layout"}
                      options={layout}
                    />
                  )}
                </Paper>
              )}
            </Stack>
          )
        )}
      </DialogContent>
    </>
  );
}

export default SPO2Report;
